import { koTypesApi } from "@src/api/konstrObjs/koTypes";
import type { ApiKoType } from "@src/api/konstrObjs/koTypes";
import { stockObjsApi } from "./api.core";
import type { ApiStockObj, ApiStockObjFilter, StockObj, StockObjExtends } from "./types";

/**
 * Сервисный слой — ТМЦ с опциональным обогащением типа КО.
 */
export const stockObjsServices = {
    ...stockObjsApi,

    /**
     * Загружает ТМЦ и при необходимости обогащает их типом конструкторского объекта.
     * Сервис гарантирует согласованное наполнение `KoTypeObj` при запросе `include`.
     */
    loadByFilter: async (params: {
        flt?: ApiStockObjFilter;
        include?: Array<keyof StockObjExtends>;
    }): Promise<StockObj[]> => {
        const { flt, include } = params;
        const objs = await stockObjsApi.load({ flt }, undefined);

        if (include == null) {
            return objs.map((obj) => serialize(obj));
        }

        const koTypeCodes = new Set<number>();
        const includeKoType = include.includes("KoTypeObj");

        objs.forEach((obj) => {
            if (includeKoType && obj.KoType !== 0) koTypeCodes.add(obj.KoType);
        });

        const koTypes = new Map<number, ApiKoType>();

        if (includeKoType && koTypeCodes.size > 0) {
            const loadedKoTypes = await koTypesApi.load({ flt: { Codes: [...koTypeCodes] } });
            loadedKoTypes.forEach((koType) => koTypes.set(koType.Code, koType));
        }

        return objs.map((obj) =>
            serialize(obj, {
                KoTypeObj: includeKoType ? koTypes.get(obj.KoType) : undefined,
            }),
        );
    },
} as const;

function serialize(apiData: ApiStockObj, includeData?: Partial<StockObjExtends>): StockObj {
    return {
        ...apiData,
        KoTypeObj: includeData?.KoTypeObj,
    };
}
